import React, { useState, useEffect } from "react";
import {
  updateProduct,
  getSingleProduct,
  clearError,
  clearMessage,
} from "../redux/productSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

export default function EditProduct() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { loading, error, message, singleproduct } = useSelector(
    (state) => state.products
  );
  const [imageFile, setImageFile] = useState(null);
  const [productData, setProductData] = useState({
    productName: "",
    category: "",
    color: "",
    size: "",
    packStock: "",
    unitStock: "",
    sellingPricePack: "",
    sellingPriceUnit: "",
    purchasePricePack: "",
    purchasePriceUnit: "",
    unitsInPack: "",
    image: null,
  });

  useEffect(() => {
    if (id) {
      dispatch(getSingleProduct(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (singleproduct) {
      setProductData({
        productName: singleproduct.productName || "",
        category: singleproduct.category || "",
        color: singleproduct.color || "",
        size: singleproduct.size || "",
        packStock: singleproduct.packStock || "",
        unitStock: singleproduct.unitStock || "",
        sellingPricePack: singleproduct.sellingPricePack || "",
        sellingPriceUnit: singleproduct.sellingPriceUnit || "",
        purchasePricePack: singleproduct.purchasePricePack || "",
        purchasePriceUnit: singleproduct.purchasePriceUnit || "",
        unitsInPack: singleproduct.unitsInPack || "",
        image: singleproduct.image || null,
      });
    }
  }, [singleproduct]);

  useEffect(() => {
    if (error) {
      toast(error);
      setTimeout(() => {
        dispatch(clearError());
      }, 3000);
    }
    if (message) {
      toast(message);
      setTimeout(() => {
        dispatch(clearMessage());
      }, 3000);
    }
  }, [error, message, dispatch]);

  const handleChange = (name, value) => {
    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const updatedData = {};
    Object.keys(productData).forEach((key) => {
      if (productData[key] !== singleproduct[key]) {
        updatedData[key] = productData[key];
      }
    });

    if (imageFile) {
      updatedData.image = imageFile;
    }

    const formData = new FormData();
    for (const key in updatedData) {
      formData.append(key, updatedData[key]);
    }
    formData.append("id", id);
    try {
      dispatch(updateProduct(formData));
    } catch (error) {
      console.error("Error uploading data:", error);
    }
  };
  return (
    <>
      <div className="w-full max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-6">
        <ToastContainer />
        <div className="mb-6">
          <h2 className="text-center text-xl text-gray-800 font-semibold">
            Product Information
          </h2>
          <p className="text-gray-600 text-sm text-center mt-2">
            Provide the basic details of the product you want to add to the
            inventory.
          </p>
        </div>

        <div className="space-y-4">
          <input
            type="text"
            value={productData.productName}
            onChange={(e) => handleChange("productName", e.target.value)}
            placeholder="Product Name"
            className="w-full h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
          />

          <input
            type="text"
            value={productData.category}
            onChange={(e) => handleChange("category", e.target.value)}
            placeholder="Category"
            className="w-full h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
          />

          <div className="grid grid-cols-2 gap-4">
            <input
              type="text"
              value={productData.color}
              onChange={(e) => handleChange("color", e.target.value)}
              placeholder="Color"
              className="h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
            />
            <input
              type="text"
              value={productData.size}
              onChange={(e) => handleChange("size", e.target.value)}
              placeholder="Size"
              className="h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <input
              type="number"
              value={productData.sellingPricePack}
              onChange={(e) => handleChange("sellingPricePack", e.target.value)}
              placeholder="Selling Price per Pack"
              className="h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
            />
            <input
              type="number"
              value={productData.purchasePricePack}
              onChange={(e) =>
                handleChange("purchasePricePack", e.target.value)
              }
              placeholder="Purchase Price per Pack"
              className="h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <input
              type="number"
              value={productData.sellingPriceUnit}
              onChange={(e) => handleChange("sellingPriceUnit", e.target.value)}
              placeholder="Selling Price per Unit"
              className="h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
            />
            <input
              type="number"
              value={productData.purchasePriceUnit}
              onChange={(e) =>
                handleChange("purchasePriceUnit", e.target.value)
              }
              placeholder="Purchase Price per Unit"
              className="h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <input
              type="number"
              value={productData.unitsInPack}
              onChange={(e) => handleChange("unitsInPack", e.target.value)}
              placeholder="Units in One Pack"
              className="h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
            />
            <input
              type="date"
              value={productData.purchaseDate}
              onChange={(e) => handleChange("purchaseDate", e.target.value)}
              placeholder="Purchase Date"
              className="h-14 bg-gray-100 text-gray-900 rounded-lg px-4 text-lg shadow-sm"
            />
          </div>
          <input
            id="file-input"
            type="file"
            className="hidden"
            onChange={(e) => setImageFile(e.target.files[0])}
          />

          <button
            onClick={() => document.getElementById("file-input").click()}
            className="w-full bg-indigo-600 hover:bg-indigo-700 py-3 px-6 rounded-lg flex items-center justify-center text-white"
          >
            Upload Product Image
          </button>

          <button
            onClick={handleSubmit}
            className="w-full bg-green-600 hover:bg-green-700 py-3 px-6 rounded-lg text-white text-lg"
          >
            {loading ? "Processing..." : "Submit"}
          </button>
        </div>
      </div>
    </>
  );
}
